module.exports = __webpack_public_path__ + "static/img/yfalert2.1ee9cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/yfalert2.png
// module id = 397
// module chunks = 0